




























import Vue from 'vue';


export default Vue.extend({
  data() {
    return{
      website: '',
      generatedQrCodeUrl: '',
    };
  },
  methods: {
    generateQrCode() {
      this.generatedQrCodeUrl
        = `http://api.qrserver.com/v1/create-qr-code/?data=${this.website}&size=100x100`;
    },
    isWebsite() {
      /* eslint-disable-next-line */
      const regex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/g;
      return this.website.match(regex) === null;
    },
  },
});
